"use client";
import { j as u } from "./jsx-runtime-CJ-St4mQ.mjs";
import { forwardRef as y } from "react";
import { t as f } from "./tv.config-BuYIgndg.mjs";
const j = f({
  base: [""],
  variants: {
    container: {
      true: ["Grid__Container grid grid-cols-12"]
    },
    item: {
      true: ["Gird__Item", "grid-cols-none", "col-span-12"]
    },
    spacing: {
      0: ["gap-0"],
      "0.5": ["gap-1"],
      1: ["gap-2"],
      2: ["gap-4"],
      3: ["gap-6"],
      4: ["gap-8"],
      8: ["gap-16"],
      12: ["gap-24"]
    },
    rowSpacing: {
      0: ["gap-y-0"],
      "0.5": ["gap-y-1"],
      1: ["gap-y-2"],
      2: ["gap-y-4"],
      3: ["gap-y-6"],
      4: ["gap-y-8"],
      8: ["gap-y-16"],
      12: ["gap-y-24"]
    },
    columnSpacing: {
      0: ["gap-x-0"],
      "0.5": ["gap-x-1"],
      1: ["gap-x-2"],
      2: ["gap-x-4"],
      3: ["gap-x-6"],
      4: ["gap-x-8"],
      8: ["gap-x-16"],
      12: ["gap-x-24"]
    },
    xs: {
      1: ["xs:col-span-1"],
      2: ["xs:col-span-2"],
      3: ["xs:col-span-3"],
      4: ["xs:col-span-4"],
      5: ["xs:col-span-5"],
      6: ["xs:col-span-6"],
      7: ["xs:col-span-7"],
      8: ["xs:col-span-8"],
      9: ["xs:col-span-9"],
      10: ["xs:col-span-10"],
      11: ["xs:col-span-11"],
      12: ["xs:col-span-12"]
    },
    sm: {
      1: ["sm:col-span-1"],
      2: ["sm:col-span-2"],
      3: ["sm:col-span-3"],
      4: ["sm:col-span-4"],
      5: ["sm:col-span-5"],
      6: ["sm:col-span-6"],
      7: ["sm:col-span-7"],
      8: ["sm:col-span-8"],
      9: ["sm:col-span-9"],
      10: ["sm:col-span-10"],
      11: ["sm:col-span-11"],
      12: ["sm:col-span-12"]
    },
    md: {
      1: ["md:col-span-1"],
      2: ["md:col-span-2"],
      3: ["md:col-span-3"],
      4: ["md:col-span-4"],
      5: ["md:col-span-5"],
      6: ["md:col-span-6"],
      7: ["md:col-span-7"],
      8: ["md:col-span-8"],
      9: ["md:col-span-9"],
      10: ["md:col-span-10"],
      11: ["md:col-span-11"],
      12: ["md:col-span-12"]
    },
    lg: {
      1: ["lg:col-span-1"],
      2: ["lg:col-span-2"],
      3: ["lg:col-span-3"],
      4: ["lg:col-span-4"],
      5: ["lg:col-span-5"],
      6: ["lg:col-span-6"],
      7: ["lg:col-span-7"],
      8: ["lg:col-span-8"],
      9: ["lg:col-span-9"],
      10: ["lg:col-span-10"],
      11: ["lg:col-span-11"],
      12: ["lg:col-span-12"]
    },
    justifyContent: {
      center: ["justify-center"],
      start: ["justify-start"],
      end: ["justify-end"],
      between: ["justify-between"],
      evenly: ["justify-evenly"],
      stretch: ["justify-stretch"]
    },
    divideColumn: {
      true: ["divide-x divide-gray-300"]
    }
  },
  compoundVariants: [
    {
      container: !0,
      justifyContent: "center",
      className: "items-center"
    },
    {
      container: !0,
      item: !0,
      className: ["grid-cols-12"]
    }
  ]
}), N = y(
  (s, a) => {
    const {
      container: n,
      justifyContent: p,
      spacing: o,
      rowSpacing: c,
      columnSpacing: l,
      divideColumn: t,
      item: e,
      xs: g,
      sm: m,
      md: i,
      lg: r,
      className: d,
      ...x
    } = s;
    return /* @__PURE__ */ u.jsx(
      "div",
      {
        ...x,
        ref: a,
        className: j({
          container: n,
          justifyContent: p,
          item: e,
          spacing: o,
          rowSpacing: c,
          columnSpacing: l,
          divideColumn: t,
          xs: g,
          sm: m,
          md: i,
          lg: r,
          class: d
        })
      }
    );
  }
);
export {
  N as default
};
